module.exports = __webpack_public_path__ + "static/media/article-table-medium-condensed.23936738.png";